<template>
    <div
        :id="id"
        class="double-click"
    />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { inventory } from '~/assets/services/doubleClick';
import watchOnce from '~/mixins/watchOnce';

const { mapState, mapActions } = createNamespacedHelpers('googleServices');

export default {
    name: 'DoubleClickWrapper',
    mixins: [watchOnce],
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            slot: null,
        };
    },
    computed: {
        ...mapState({
            isGPT: state => state.GPT,
        }),
        slotData() {
            return inventory.find(slotId => slotId.id === this.id);
        },
    },
    beforeDestroy() {
        if (this.slot) {
            window.googletag.destroySlots([this.slot]);
            this.unregisterDoubleClickSlot(this.slotData.id);
        }
    },
    mounted() {
        if (this.isGPT) {
            this.displayAds();
        } else {
            this.watchOnce({
                key: 'isGPT',
                callback: this.displayAds,
            });
        }
    },
    methods: {
        ...mapActions(['registerDoubleClickSlot', 'unregisterDoubleClickSlot']),
        displayAds() {
            const { path, size, domId } = this.slotData;
            const slot = window.googletag.defineSlot(path, size, domId);

            if (slot) {
                this.slot = slot;
                this.registerDoubleClickSlot({
                    id: this.slotData.id,
                    data: this.slotData,
                    gptSlot: this.slot,
                });
            }
        },
    },
};
</script>

<style lang="scss">
    .double-click,
    .double-click > div {
        text-align: center;
        position: relative;
        z-index: 1;
        background: transparent;
        border: 0;
        height: auto;

        iframe {
            max-width: 100%;
            max-height: 100%;
        }
    }
</style>
